import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'
import { Modal, WhiteSpace, WingBlank } from 'antd-mobile'
import { Button, Toast } from 'antd-mobile-v5'
import { getSubmitOssFormat, showAlert, showModal } from './utils'
import PaymentBtn from '../FormTools/PaymentBtn'
import AgreementPopup from '../FormTools/AgreementPopup'
import StepStatus from '../FormTools/StepStatus'
import FuiouQrPopup from '../FormTools/FuiouQrPopup'
import {
  isFuiouQrChannel,
  isValidWposQrContent,
  pickFuiouChannel,
  safeExternalRedirect,
  safeFuiouRedirect,
  createWposPayTypePicker,
  FUIOU_H5_PAY_TYPE,
  FUIOU_PAY_TYPES,
} from '../FormTools/utils'
import { isTaiwanUser } from '../../utils/user'
import { getWechatOpenId } from '../../utils/wechat'

import styles from '../../pages/DiveMasterForm/DiveMasterForm.module.css'

const paymentTypeList = [
  'MEMBER_APPLICATION_PADI_MERMAID_I',
  'MEMBER_APPLICATION_PADI_BASIC_MERMAID_I',
  'MEMBER_APPLICATION_FDI',
  'MEMBER_APPLICATION_AFDI',
  'MEMBER_APPLICATION_MFDI',
  'MEMBER_APPLICATION_DM',
]

const DetailStatusContent = ({
  approveFn,
  payFn,
  listUrl,
  detail,
  isStore,
  agreement,
  payApplicationType,
  toPay,
  setVisible,
  getSubmitData,
  form,
  signature,
}) => {
  const { replace, push } = useHistory()
  const { formatMessage } = useIntl()
  const { profile } = useSelector((state) => ({
    profile: state.data.profile,
  }))

  const { status, note, code, paymentMethod, paymentType } = detail
  const editableStatus = status === 'ADMIN_NOT_APPROVED' || status === 'WAIT_CONFIRM'

  const approvedAction = async (approve) => {
    await form.validateFields()
    if (!signature) {
      showModal(
        formatMessage({ id: 'common-errorTitle' }),
        formatMessage({ id: 'dm-form-signature-confirm' }),
        () => {},
        () => {},
        formatMessage({ id: 'common-comfirmBtn' }),
        formatMessage({ id: 'common-cancel' })
      )
      return
    }
    if (agreement === false) {
      showModal(
        formatMessage({ id: 'common-errorTitle' }),
        formatMessage({ id: 'common-check-agreement' }),
        () => {},
        () => {},
        formatMessage({ id: 'common-comfirmBtn' }),
        formatMessage({ id: 'common-cancel' })
      )
      return
    }
    if (approve) {
      await submitApprovedFn()
    } else {
      Modal.prompt(formatMessage({ id: 'dm-refuse-reason' }), formatMessage({ id: 'dm-refuse-tips' }), [
        { text: formatMessage({ id: 'common-cancel' }) },
        {
          text: formatMessage({ id: 'common-comfirmBtn' }),
          onPress: async (value) => {
            if (!value) {
              showModal(
                '',
                formatMessage({ id: 'dm-refuse-error' }),
                () => {},
                () => {},
                formatMessage({ id: 'common-comfirmBtn' }),
                formatMessage({ id: 'common-cancel' })
              )
              return
            }
            const approvedData = {
              approve,
              code: detail.code,
              handwrittenSignatureUrl: getSubmitOssFormat(signature),
              note: value,
            }
            try {
              Toast.show({ icon: 'loading', duration: 0 })
              const response = await approveFn(approvedData)
              if (response.error) {
                showAlert(response.error.clientMsg, formatMessage({ id: 'common-close' }))
              } else {
                replace(listUrl)
              }
            } catch (e) {
              showAlert(formatMessage({ id: 'common-errorStatus' }), formatMessage({ id: 'common-close' }))
            } finally {
              Toast.clear()
            }
          },
        },
      ])
    }
  }

  const submitApprovedFn = async () => {
    showModal(
      '',
      formatMessage({ id: 'dm-form-instructor-accept-confirm' }),
      async () => {
        let approvedData = {
          approve: true,
          code: detail.code,
          handwrittenSignatureUrl: getSubmitOssFormat(signature),
        }
        if (editableStatus) {
          const formData = getSubmitData()
          approvedData = {
            ...formData,
            ...approvedData,
          }
        }
        try {
          Toast.show({ icon: 'loading', duration: 0 })
          const response = await approveFn(approvedData)
          if (response.error) {
            showAlert(response.error.clientMsg, formatMessage({ id: 'common-close' }))
          } else {
            if (!paymentMethod) {
              if (profile.teachingLocation === 'TW' || isTaiwanUser()) {
                if (paymentTypeList.indexOf(payApplicationType) >= 0) {
                  Modal.alert('', formatMessage({ id: 'BMI-trainer-review-reminder' }), [
                    { text: formatMessage({ id: 'common-yes' }), onPress: () => setVisible(true) },
                    { text: formatMessage({ id: 'common-no' }), onPress: () => push(listUrl) },
                  ])
                }
              } else {
                Modal.alert('', formatMessage({ id: 'BMI-trainer-review-reminder' }), [
                  { text: formatMessage({ id: 'common-yes' }), onPress: () => toPay(detail.code) },
                  { text: formatMessage({ id: 'common-no' }), onPress: () => push(listUrl) },
                ])
              }
            } else {
              push(listUrl)
            }
          }
        } catch (e) {
          showAlert(formatMessage({ id: 'common-errorStatus' }), formatMessage({ id: 'common-close' }))
        } finally {
          Toast.clear()
        }
      },
      () => {},
      formatMessage({ id: 'common-comfirmBtn' }),
      formatMessage({ id: 'common-cancel' })
    )
  }

  switch (status) {
    case 'WAIT_CONFIRM':
      if (isStore) {
        return <StepStatus desc={formatMessage({ id: 'app-wait-ins-review' })} />
      }
      return (
        <div className={styles.btns}>
          <Button inline color="primary" className={styles.btn} onClick={() => approvedAction(true)}>
            <FormattedMessage id="dm-form-agree" />
          </Button>
          <Button inline color="warning" className={styles.btn} onClick={() => approvedAction(false)}>
            <FormattedMessage id="dm-form-reject" />
          </Button>
        </div>
      )
    case 'INSTRUCTOR_APPROVED':
      return paymentMethod ? (
        <StepStatus desc={formatMessage({ id: 'app-wait-cs-review' })} />
      ) : !paymentType ? null : (
        <>
          <WhiteSpace />
          <WingBlank>
            <PaymentBtn code={code} paymentFn={payFn} payApplicationType={payApplicationType} />
          </WingBlank>
        </>
      )
    case 'INSTRUCTOR_NOT_APPROVED':
      return <StepStatus desc={formatMessage({ id: 'app-status-instructor-not-approved' })} />
    case 'ADMIN_NOT_APPROVED':
      return (
        <>
          <div className={styles.btns}>
            <Button inline color="primary" className={styles.btn} onClick={() => approvedAction(true)}>
              <FormattedMessage id="dm-form-agree" />
            </Button>
            <Button inline color="warning" className={styles.btn} onClick={() => approvedAction(false)}>
              <FormattedMessage id="dm-form-reject" />
            </Button>
          </div>
          <StepStatus desc={formatMessage({ id: 'app-cs-not-approved' })} note={note} />
        </>
      )
    case 'ADMIN_APPROVED':
    case 'PASS':
      return <StepStatus desc={formatMessage({ id: 'app-wait-cert' })} />
    case 'NOT_PASS':
      return <StepStatus desc={formatMessage({ id: 'owsi-not-pass' })} />
    case 'INSTRUCTOR_CREATED':
      return <StepStatus desc={formatMessage({ id: 'app-wait-applicant-confirm' })} />
    case 'SUCCESS':
      return <StepStatus desc={formatMessage({ id: 'app-success' })} />
    case 'CLOSE':
      return <StepStatus desc={formatMessage({ id: 'app-close' })} />
    default:
      return null
  }
}

const DetailStatus = ({ ...props }) => {
  const [visible, setVisible] = useState(false)
  const [qrVisible, setQrVisible] = useState(false)
  const [qrUrl, setQrUrl] = useState('')
  // 应付金额（CHNA-2618：申请类端点本就返回 price/currency，透传给弹窗展示）
  const [qrPrice, setQrPrice] = useState(null)
  const [qrCurrency, setQrCurrency] = useState(null)
  const [qrPayType, setQrPayType] = useState(null)
  const [qrCode, setQrCode] = useState('')
  const wposPickerRef = useRef(null)
  // await picker 后组件可能已卸载：setState 前判 mounted 防卸载告警
  const mountedRef = useRef(true)
  const { formatMessage } = useIntl()
  const { push } = useHistory()
  const { profile } = useSelector((state) => ({
    profile: state.data.profile,
  }))

  // 组件卸载时清理残留的命令式渠道选择面板
  useEffect(() => {
    // StrictMode 下 effect 会 setup→cleanup→setup 重跑：cleanup 置 false 后必须复位，
    // 否则重挂载后 mountedRef 恒 false，支付回调全部失效
    mountedRef.current = true
    return () => {
      mountedRef.current = false
      if (wposPickerRef.current) {
        wposPickerRef.current.close()
        wposPickerRef.current = null
      }
    }
  }, [])

  const supportsFuiou = FUIOU_PAY_TYPES.includes(props.payApplicationType)

  const buildPayParams = async (code) => {
    // TW 用户/海外环境不参与富友迁移：直接走旧支付通道（后端按地区路由 TradeVan 整页跳转），
    // 不弹微信/支付宝渠道选择
    if (profile.teachingLocation === 'TW' || isTaiwanUser()) return code
    if (!supportsFuiou) return code
    const channel = pickFuiouChannel()
    // 微信内 H5PAY 用 WeJsapiPay；PC WPOS 先选渠道（微信/支付宝），FAPPLET 聚合码已下线
    if (channel === 'H5PAY')
      return { code, channel, payType: FUIOU_H5_PAY_TYPE.WECHAT_JSAPI, openid: getWechatOpenId() }
    const picker = createWposPayTypePicker(formatMessage)
    wposPickerRef.current = picker
    const payType = await picker.promise
    wposPickerRef.current = null
    // 用户取消渠道选择，静默返回
    if (!payType) return null
    if (mountedRef.current) setQrPayType(payType)
    return { code, channel, payType }
  }

  const toPay = async (code) => {
    const params = await buildPayParams(code)
    // 用户取消 WPOS 渠道选择
    if (params === null) return
    let result
    try {
      result = await props.payFn(params)
    } catch (error) {
      // payFn 为 runAsync（失败恒 reject）时 {error} 信封不可达，统一转信封形态走既有错误分支
      result = { error: { clientMsg: (error && error.clientMsg) || formatMessage({ id: 'fuiou-pay-fail' }) } }
    }
    if (result.error) {
      showAlert(result.error.clientMsg, formatMessage({ id: 'common-close' }))
      return
    }
    if (result.url) {
      if (supportsFuiou && result.paymentMethodType === 'FUIOU') {
        if (isFuiouQrChannel()) {
          // QR 渲染不经 safeFuiouRedirect，此处单独过二维码内容白名单
          // （单码通道返回渠道二维码内容，兼容历史富友聚合链接形态）
          if (!isValidWposQrContent(result.url)) {
            Toast.show({ icon: 'fail', content: formatMessage({ id: 'fuiou-pay-url-invalid' }) })
            return
          }
          setQrUrl(result.url)
          setQrPrice(result.price)
          setQrCurrency(result.currency)
          setQrCode(result.code || code)
          setQrVisible(true)
          return
        }
        safeFuiouRedirect(result.url, formatMessage({ id: 'fuiou-pay-url-invalid' }))
        return
      }
      if (profile.teachingLocation === 'TW')
        return push('/invoice_form', { code, nextUrl: result.url, type: props.payApplicationType })
      safeExternalRedirect(result.url, formatMessage({ id: 'fuiou-pay-url-invalid' }), {
        // 白名单外域名弹确认（message 由 safeExternalRedirect 以 hostname 调用）
        message: (host) => formatMessage({ id: 'fuiou-external-redirect-confirm' }, { host }),
        confirm: formatMessage({ id: 'common-comfirmBtn' }),
        cancel: formatMessage({ id: 'common-cancel' }),
      })
    } else {
      // 下单成功但无 url（异常形态）：提示失败，避免静默无反馈
      Toast.show({ icon: 'fail', content: formatMessage({ id: 'fuiou-pay-fail' }) })
    }
  }

  const onPaymentSuccess = useCallback(() => {
    setQrVisible(false)
    Toast.show({
      icon: 'success',
      content: formatMessage({ id: 'fuiou-pay-success' }),
      afterClose: () => window.location.reload(),
    })
  }, [formatMessage])

  const handleCloseQr = useCallback(() => {
    setQrVisible(false)
  }, [])

  return (
    <>
      <DetailStatusContent {...props} toPay={toPay} setVisible={setVisible} />
      <AgreementPopup visible={visible} setVisible={setVisible} toPay={() => toPay(props.detail.code)} />
      <FuiouQrPopup
        visible={qrVisible}
        url={qrUrl}
        price={qrPrice}
        currency={qrCurrency}
        onClose={handleCloseQr}
        onPaymentSuccess={onPaymentSuccess}
        payApplicationType={props.payApplicationType}
        code={qrCode || props.detail.code}
        payType={qrPayType}
      />
    </>
  )
}

export default DetailStatus
